// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2hurP","label":"Radio_label__KpI9j","checkMark":"Radio_checkMark__38LJf","disabled":"Radio_disabled__3C9HW"};